(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("nc-lightapp-front"), require("babel-polyfill"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "nc-lightapp-front", "babel-polyfill"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-dom"), require("nc-lightapp-front"), require("babel-polyfill")) : factory(root["React"], root["ReactDOM"], root["nc-lightapp-front"], root["babel-polyfill"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__91__, __WEBPACK_EXTERNAL_MODULE__635__) {
return 